export const languageCodes = ['nl', 'en'];
// const development = false;

// export const backendBaseUrl5 = development
//     ? '/edu/game5/api/'
//     : 'https://www.digigreenhouse.wur.nl/edu/game5/api/';
export const backendBaseUrl5 = './api/';

// export const helpUrl = 'https://wiki.groenkennisnet.nl/display/G2/';

export const browserStoragePrefix = 'kassimGame5.';
